import { cloneElement, isValidElement } from 'react';
import { useProgramIdentity } from '../context/ProgramIdentityContext';

export default function ActiveApplicationGate({ application, children }) {
  const { identity, loading, error, isApplicationActive } = useProgramIdentity();

  if (isApplicationActive(application)) return children;

  const loadedLabel = identity?.active_application_label;
  let message = "Identification du programme PLC en cours. Les animations et commandes restent désactivées.";
  if (error) {
    message = "Identité du programme PLC indisponible. Les animations et commandes restent désactivées par sécurité.";
  } else if (!loading && loadedLabel) {
    message = `Cette application est désactivée car le PLC exécute « ${loadedLabel} ».`;
  } else if (!loading && identity?.raw_value != null) {
    message = `La valeur ${identity.raw_value} du registre ${identity.register} n'identifie aucun programme autorisé.`;
  }

  const preview = isValidElement(children) && typeof children.type !== 'string'
    ? cloneElement(children, { inactivePreview: true })
    : children;

  return (
    <div className="application-preview">
      <section className="application-preview-notice" role="status">
        <strong>Aperçu neutre — programme non chargé</strong>
        <span>{message}</span>
      </section>
      {preview}
    </div>
  );
}
